<template>
  <v-container class="content-wrapper" fluid>
    <!-- Toggle Buttons -->
    <v-row class="mt-2">
      <v-spacer></v-spacer>
      <v-col cols="2"></v-col>
      <v-col cols="12" sm="6" md="6" class="d-flex justify-center">
        <v-row no-gutters class="d-flex justify-center overflow-x-auto">
          <v-btn-toggle v-model="toggleTab" rounded mandatory class="d-flex">
            <v-btn
              v-if="!filtered"
              value="scientific"
              class="btn-selected"
              @click="toggleTab = 'scientific'"
            >
              Scientific Domain
            </v-btn>
            <v-btn
              v-if="!filtered"
              value="hosting-institution"
              class="btn-selected"
              @click="toggleTab = 'hosting-institution'"
            >
              Hosting Institution
            </v-btn>
            <v-btn
              v-show="!filtered"
              value="view-all"
              class="btn-selected"
              @click="toggleTab = 'view-all'"
            >
              View All
            </v-btn>
          </v-btn-toggle>
        </v-row>
      </v-col>

      <v-spacer></v-spacer>
    </v-row>
    <v-row>
      <v-spacer></v-spacer>
      <v-col
        v-if="toggleTab === 'view-all'"
        cols="8"
        xl="8"
        lg="12"
        md="12"
        sm="12"
        class="d-flex justify-end"
      >
        <v-select
          v-model="sortBy"
          :items="itemsSortBy"
          dense
          style="max-width: 245px"
          outlined
          label="Sort By"
          rounded
          hide-details
          return-object
          @input="changeSortBy"
        >
        </v-select>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>

    <!-- Filters -->
    <v-row class="mt-0">
      <v-spacer></v-spacer>
      <v-col cols="12" xl="2" lg="3" md="3" sm="12" xs="12">
        <v-row>
          <v-col cols="12">
            <v-card elevation="3" style="border-radius: 24px;">
              <v-card-text>
                <v-text-field
                  v-model.trim="equipment.text"
                  rounded
                  placeholder="Search"
                  outlined
                  dense
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                ></v-text-field>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Hosting Institution:</label>
                <v-autocomplete
                  v-model="equipment.institutions"
                  class="mt-2"
                  :items="institutions"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Hosting Institution'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Provider:</label>
                <v-autocomplete
                  v-model="equipment.providers"
                  class="mt-2"
                  :items="providers"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Provider'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific Domain:</label>
                <v-autocomplete
                  v-model="equipment.domains"
                  class="mt-2"
                  :items="domains"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Domain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Scientific SubDomain:</label>
                <v-autocomplete
                  v-model="equipment.subDomains"
                  class="mt-2"
                  :items="filteredSubDomains"
                  :item-value="'id'"
                  :item-text="'subDomain'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Scientific Subdomain'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Sub Category:</label>
                <v-autocomplete
                  v-model="equipment.subCategories"
                  class="mt-2"
                  :items="subCategories"
                  :item-value="'id'"
                  :item-text="'subCategory'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Subcategory'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Access Mode:</label>
                <v-autocomplete
                  v-model="equipment.accessModes"
                  class="mt-2"
                  :items="accessModes"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Access Mode'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Access Type:</label>
                <v-autocomplete
                  v-model="equipment.accessTypes"
                  class="mt-2"
                  :items="accessTypes"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Access Type'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Target Users:</label>
                <v-autocomplete
                  v-model="equipment.targetUsers"
                  class="mt-2"
                  :items="targetUsers"
                  :item-value="'id'"
                  :item-text="'name'"
                  outlined
                  multiple
                  clearable
                  :placeholder="'Target Users'"
                  hide-details
                  dense
                >
                </v-autocomplete>
              </v-card-text>
              <v-card-text class="mt-0 pt-0">
                <label class="primary200--text">Orderable:</label>
                <v-switch v-model="equipment.orderable" color="success" class="required">
                </v-switch>
              </v-card-text>
              <v-card-actions class="mt-0 pt-0">
                <v-col cols="6" class="d-flex justify-end">
                  <v-btn
                    @click="clear"
                    outlined
                    block
                    depressed
                    large
                    text
                    class="primary200--text font-weight-bold"
                  >
                    Clear
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-btn
                    @click="triggerFilters"
                    :disabled="!isEquipmentValid"
                    block
                    depressed
                    rounded
                    large
                    color="primary200"
                    class="white--text font-weight-bold"
                    data-cy="submit"
                    >Done
                  </v-btn>
                </v-col>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" xl="6" lg="9" md="9" sm="12" xs="12">
        <!-- Scientifics  -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'scientific' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="scientific in scientifics"
            :key="'scientific-' + scientific.name"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterDomain(scientific)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <img v-bind:src="require('@/assets/svg/scientific/' + scientific.icon)" />
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ scientific.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- Hosting Institutions -->
        <v-row class="mb-10 justify-start" v-if="toggleTab === 'hosting-institution' && !filtered">
          <v-col
            cols="12"
            xl="3"
            lg="4"
            md="6"
            sm="6"
            xs="12"
            class="pa-3"
            v-for="institution in institutions"
            :key="'institution-' + institution.id"
          >
            <v-hover v-slot="{ hover }">
              <v-card
                class="justify-center align-center"
                elevation="3"
                style="border-radius: 24px; height: 100%; "
                :class="{ 'on-hover': hover }"
                @click="filterInstitution(institution)"
              >
                <v-card-text>
                  <v-row class="text-center">
                    <v-col cols="12">
                      <v-avatar size="150px" class="rounded-xl">
                        <v-img contain :src="institution.logoUrl">
                          <template v-slot:placeholder>
                            <v-img lazy-src="@/assets/img/blur.jpg"></v-img>
                          </template>
                        </v-img>
                      </v-avatar>
                    </v-col>
                    <v-col cols="12" class="mt-12 primary300--text">
                      <b>{{ institution.name }}</b>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>

        <!-- View All -->
        <v-row v-if="toggleTab === 'view-all' && !filtered">
          <MarketplaceEquipmentViewAll :sortParams="sortParams"></MarketplaceEquipmentViewAll>
        </v-row>
        <!-- Filtered View ALl -->
        <v-row v-if="filtered">
          <MarketplaceEquipmentFilteredViewAll
            :filteredParams="params"
            :sortParams="sortParams"
            @changeTab="toggleChangeTab"
          ></MarketplaceEquipmentFilteredViewAll>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
    </v-row>
  </v-container>
</template>

<script>
import scientificsJs from '@/configs/scientifics.json';
import MarketplaceEquipmentViewAll from './MarketplaceEquipmentViewAll.vue';
import MarketplaceEquipmentFilteredViewAll from './MarketplaceEquipmentFilteredViewAll.vue';

export default {
  name: 'BrowseCatalogueEquipment',
  components: { MarketplaceEquipmentViewAll, MarketplaceEquipmentFilteredViewAll },
  data() {
    return {
      toggleTab: 'scientific',
      scientifics: scientificsJs,
      equipment: {
        institutions: [],
        providers: [],
        domains: [],
        subDomains: [],
        subCategories: [],
        accessModes: [],
        accessTypes: [],
        targetUsers: [],
        text: '',
        orderable: true,
      },
      institutions: [],
      providers: [],
      domains: [],
      allSubDomains: [],
      subCategories: [],
      accessModes: [],
      accessTypes: [],
      targetUsers: [],
      filtered: false,
      params: {},
      sortParams: '',
      marketplaceEquipmentViewAll: '',
      sortBy: null,
      itemsSortBy: [
        { text: 'Default', value: null },
        { text: 'Recently updated', value: 'updatedTimestamp', desc: true },
        { text: 'Recently added', value: 'createdTimestamp', desc: true },
        { text: 'A-Z', value: 'name', desc: false },
      ],
      queries: {},
      hasDefinedParams: {},
      initialToggleTab: '',
    };
  },
  props: {
    toggleButton: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.axios.get('/api/v1/hosting-institutions/all').then(res => {
      this.institutions = res.data;
    });
    this.axios.get('/api/v1/providers/light?size=-1').then(res => {
      this.providers = res.data.content;
    });
    this.axios.get('/api/v1/scientific-domains').then(res => {
      this.domains = res.data.content;
    });
    this.axios.get('/api/v1/scientific-subdomains').then(res => {
      this.allSubDomains = res.data.content;
    });
    this.axios.get('/api/v1/subcategories-equipment').then(res => {
      this.subCategories = res.data.content;
    });
    this.axios.get('/api/v1/access-modes').then(res => {
      this.accessModes = res.data.content;
    });
    this.axios.get('/api/v1/access-types').then(res => {
      this.accessTypes = res.data.content;
    });
    this.axios.get('/api/v1/targets').then(res => {
      this.targetUsers = res.data.content;
    });
    this.marketplaceEquipmentViewAll = this.$route.query.marketplaceEquipmentViewAll;
    if (this.marketplaceEquipmentViewAll) {
      this.toggleTab = 'view-all';
    }
    if (this.toggleButton) {
      const valueOfToggleButton = this.toggleButton;
      this.toggleTab = valueOfToggleButton;
    }
  },
  created() {
    this.queries = this.$route.query;
    if (this.queries) {
      const paramsQueries = {
        domains: this.queries.domains,
        institutions: this.queries.institutions,
        subDomains: this.queries.subDomains,
        text: this.queries.text,
        accessModes: this.queries.accessModes,
        accessTypes: this.queries.accessTypes,
        providers: this.queries.providers,
        subCategories: this.queries.subCategories,
        targets: this.queries.targets,
      };

      this.hasDefinedParams = Object.values(paramsQueries).some(value => value !== undefined);

      if (this.hasDefinedParams) {
        console.log('params', paramsQueries);
        this.filtered = true;
        this.params = paramsQueries;
      }
    }
  },
  watch: {
    toggleTab(newValue) {
      if (newValue === 'hosting-institution' || newValue === 'scientific') {
        this.sortBy = '';
        this.sortParams = this.sortBy;
      }
    },
    toggleButton(newValue) {
      if (newValue) {
        this.toggleTab = newValue;
      }
    },
    '$route.query': {
      immediate: true,
      deep: true,
      handler(query) {
        if (query.filters === 'true' && query.marketplaceEquipmentViewAll) {
          const { ...filterParams } = query;
          if (filterParams.orderable === 'true') filterParams.orderable = true;
          if (filterParams.orderable === 'false') filterParams.orderable = false;
          if (Object.keys(filterParams).length > 0) {
            this.filtered = true;
            this.params = filterParams;
            if (filterParams.text) {
              this.equipment.text = filterParams.text;
            }
            if (filterParams.orderable !== undefined) {
              this.equipment.orderable = filterParams.orderable;
            }
            if (filterParams.institutions) {
              this.equipment.institutions = filterParams.institutions.split(',').map(Number);
            }
            if (filterParams.providers) {
              this.equipment.providers = filterParams.providers.split(',').map(Number);
            }
            if (filterParams.domains) {
              const domainArray = filterParams.domains.split(/,(?=[A-Z])/);
              this.equipment.domains = domainArray.map(d => d.trim());
            }
            if (filterParams.subDomains) {
              this.equipment.subDomains = filterParams.subDomains.split(',').map(Number);
            }
            if (filterParams.subCategories) {
              this.equipment.subCategories = filterParams.subCategories.split(',').map(Number);
            }
            if (filterParams.accessModes) {
              this.equipment.accessModes = filterParams.accessModes.split(',').map(Number);
            }
            if (filterParams.accessTypes) {
              this.equipment.accessTypes = filterParams.accessTypes.split(',').map(Number);
            }
            if (filterParams.targets) {
              this.equipment.targetUsers = filterParams.targets.split(',').map(Number);
            }
          }
        }
      },
    },
  },
  computed: {
    isEquipmentValid() {
      const equipmentFields = [
        ...this.equipment.institutions,
        ...this.equipment.providers,
        ...this.equipment.domains,
        ...this.equipment.subDomains,
        ...this.equipment.subCategories,
        ...this.equipment.accessModes,
        ...this.equipment.accessTypes,
        ...this.equipment.targetUsers,
        this.equipment.text,
      ];

      return equipmentFields.some(field => field) || this.equipment.orderable !== undefined;
    },
    filteredSubDomains() {
      if (!this.equipment.domains.length) {
        return this.allSubDomains;
      }

      return this.allSubDomains.filter(equipmentDomains =>
        this.equipment.domains.includes(equipmentDomains.domain),
      );
    },
  },
  methods: {
    toggleChangeTab() {
      this.clear();
    },
    clear() {
      this.equipment.institutions = [];
      this.equipment.providers = [];
      this.equipment.domains = [];
      this.equipment.subDomains = [];
      this.equipment.subCategories = [];
      this.equipment.accessModes = [];
      this.equipment.accessTypes = [];
      this.equipment.targetUsers = [];
      this.equipment.text = '';
      this.equipment.orderable = true;
      this.filtered = false;
      if (this.initialToggleTab) {
        this.toggleTab = this.initialToggleTab;
      }
      if (this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/marketplace/equipment',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Equipment',
            marketplaceEquipmentViewAll: true,
          },
        });
      } else if (!this.$store.getters.roles && this.hasDefinedParams) {
        this.$router.push({
          path: '/public-catalogue-marketplace/equipment',
          query: {
            selectedCatalogue: 'Browse the Catalogue of Equipment',
            marketplaceEquipmentViewAll: true,
          },
        });
      }
    },
    triggerFilters() {
      const institutionIds = this.equipment.institutions.map(institution => institution);
      const providersIds = this.equipment.providers.map(provider => provider);
      const domains = this.equipment.domains.map(domain => domain);
      const subDomains = this.equipment.subDomains.map(subDomain => subDomain);
      const subCategories = this.equipment.subCategories.map(subCategory => subCategory);
      const accessModes = this.equipment.accessModes.map(accessMode => accessMode);
      const accessTypes = this.equipment.accessTypes.map(accessType => accessType);
      const targetUsers = this.equipment.targetUsers.map(targetUser => targetUser);

      const institutionParams = institutionIds.join(',');
      const providerParams = providersIds.join(',');
      const domainParams = domains.join(',');
      const subDomainsParams = subDomains.join(',');
      const subCategoriesParams = subCategories.join(',');
      const accessModesParams = accessModes.join(',');
      const accessTypesParams = accessTypes.join(',');
      const targetUsersParams = targetUsers.join(',');

      const params = {
        institutions: institutionParams,
        providers: providerParams,
        domains: domainParams,
        subDomains: subDomainsParams,
        subCategories: subCategoriesParams,
        accessModes: accessModesParams,
        accessTypes: accessTypesParams,
        targets: targetUsersParams,
        text: this.equipment.text,
        orderable: this.equipment.orderable,
      };

      this.deleteEmptyProperties(params);
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    filterInstitution(institution) {
      const institutionId = institution.id;
      const params = {
        institutions: institutionId,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    filterDomain(scientific) {
      const urlParams = new URLSearchParams(scientific.url.split('?')[1]);
      const domainUrl = urlParams.get('domains');

      const params = {
        domains: domainUrl,
      };
      this.filtered = true;
      this.params = params;
      this.initialToggleTab = this.toggleTab;
    },
    changeSortBy(selected) {
      let params = '';

      if (selected && selected.value) {
        const sortField = selected.value;
        const sortOrder = selected.desc ? 'desc' : 'asc';
        params = `sort=${sortField}+${sortOrder}`;
        this.sortParams = params;
      } else {
        this.sortParams = '';
      }
    },
  },
};
</script>

<style scoped>
.btn-selected {
  font-weight: bold;
}
</style>
